
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    SortBox: () => import("@/components/SortBox.vue"),
    Slick: () => import("vue-slick"),
    Modal: () => import("@/components/Modal.vue")
  }
})
export default class UsersIndex extends Vue {
  controlzones: any = [];
  countries: any = [];
  controlzone: any = {
    countryId: ""
  };
  country: any = {};
  currentControlZone: number = 0;

  error: boolean = false;
  error2: boolean = false;
  error3: boolean = false;
  error4: boolean = false;

  sortColumns: Record<string, string> = {
    0: "Agregar nuevo país",
    1: "Actualizar Zona de Cúmulo",
    2: "Zonas de Cúmulo"
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 2,
    centerPadding: 0,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };
  isMobile: boolean = window.innerWidth < 992;
  firstLoad: boolean = true;

  @Watch("isMobile")
  onIsMobileChange(val: boolean, old: boolean) {
    if (this.firstLoad && old === true) {
      this.firstLoad = false;
    } else {
      location.reload();
    }
  }

  handleAfterChange(event, slick, currentSlide) {
    (this.$refs.sortBox as any).update(currentSlide);
  }

  init() {
    this.loadCountries();
    this.loadControlZones();
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 992;
    });
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  async loadControlZones() {
    const response: any = await (this.$root as any)._post("controlzones/all");
    this.controlzones = response.data;
  }

  move(index) {
    (this.$refs.slick as any).goTo(index);
  }

  showDeleteModal(id: number) {
    this.currentControlZone = id;
    (this.$refs.modal as any).show();
  }

  async deleteControlZone() {
    try {
      let response: any = await (this.$root as any)._delete(
        `controlzones/${this.currentControlZone}`
      );
      this.loadControlZones();
      this.currentControlZone = 0;
      (this.$refs.modal as any).hide();
      (this.$root as any).notify("Se elimino la zona de cúmulo con éxito.");
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo eliminar la zona de cúmulo.",
        "error"
      );
    }
  }

  async createCountry() {
    if (!this.country.title) {
      this.error = true;
      return;
    }
    if (!this.country.tax) {
      this.error2 = true;
      return;
    }
    try {
      await (this.$root as any)._post("countries", this.country);
      this.loadCountries();
      this.country = {};
      (this.$root as any).notify("Se creo el país con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo crear el país.", "error");
    }
  }

  async createControlZone() {
    if (!this.controlzone.code) {
      this.error3 = true;
      return;
    }
    if (!this.controlzone.description) {
      this.error4 = true;
      return;
    }
    try {
      await (this.$root as any)._post("controlzones", this.controlzone);
      this.loadControlZones();
      this.controlzone = {
        countryId: ""
      };
      (this.$root as any).notify("Se creo la zona de cúmulo con éxito.");
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo crear la zona de cúmulo.",
        "error"
      );
    }
  }
}
